import { IPaginationResult } from '@/models/common'
const jsonPath = require('jsonpath')

class JsonPathService {
  getValueByField (source: any, accessKey: string) {
    if (typeof source === 'object') {
      const result = jsonPath.query(source, accessKey)
      if (result?.length !== 0) {
        if (result.length === 1) {
          return this.getFormattedValue(result[0])
        } else {
          return this.getFormattedValue(result)
        }
      } else {
        return null
      }
    } else {
      return null
    }
  }

  getDocumentContainerData (source: any, accessKey: string): IPaginationResult|null {
    if (source == null) {
      return null
    }

    let isDocumentContainer = false

    if (accessKey.includes('document')) {
      accessKey = accessKey.replace('$.document', '$.document.data')
      isDocumentContainer = true
    }

    if (Array.isArray(source) && (!accessKey || accessKey === '$' || accessKey === '$$')) {
      return { data: source, totalRecords: source.length }
    }

    if (typeof source === 'object') {
      try {
        const result = jsonPath.query(source, accessKey)

        if (!result || result.length === 0) {
          if (Array.isArray(source)) {
            return { data: source, totalRecords: source.length }
          }
          return null
        }

        if (Array.isArray(result) && result.length > 1) {
          if (isDocumentContainer) {
            const documents = this.getFormattedValue(result)
            const total = result.length
            return { data: documents, totalRecords: total }
          } else {
            const documents = this.getFormattedValue(result[0])
            const total = result[1]
            return { data: documents, totalRecords: total }
          }
        }

        if (result.length === 1) {
          const data = this.getFormattedValue(result[0])
          if (Array.isArray(data)) {
            return { data: data, totalRecords: data.length }
          }
          return { data: [data], totalRecords: 1 }
        }

        return null
      } catch (error) {
        return null
      }
    }

    return null
  }

  getFormattedValue (value: any) {
    if (typeof value === 'boolean') {
      if (value) {
        return 'Yes'
      }
      return 'No'
    }
    return value
  }

  getValueArrayByField (source: any, query: string) {
    return jsonPath.query(source, query)
  }
}

export default new JsonPathService()
